import { render, staticRenderFns } from "./AtigimentoMetaPeriodo.vue?vue&type=template&id=7fc48ee9&scoped=true&"
import script from "./AtigimentoMetaPeriodo.vue?vue&type=script&lang=js&"
export * from "./AtigimentoMetaPeriodo.vue?vue&type=script&lang=js&"
import style0 from "./AtigimentoMetaPeriodo.vue?vue&type=style&index=0&lang=sass&"
import style1 from "./AtigimentoMetaPeriodo.vue?vue&type=style&index=1&id=7fc48ee9&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fc48ee9",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAvatar } from 'vuetify/lib/components/VAvatar';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VAvatar,VIcon,VRow})
